//

import {
  GET_PRODUCT_LIST,
  GET_PRODUCT_LIST_SUCCESS,
  GET_PRODUCT_LIST_FAILURE,
  GET_PRODUCT_SELF_SERVE_WIDGET_RENDER,
  GET_PRODUCT_SELF_SERVE_WIDGET_RENDER_SUCCESS,
  GET_PRODUCT_SELF_SERVE_WIDGET_RENDER_FAILURE,
  POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK,
  POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK_SUCCESS,
  POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK_FAILURE,
  POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY,
  POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY_SUCCESS,
  POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY_FAILURE,
  GET_PRODUCT_LIST_NEW_API_CALL,
  GET_PRODUCT_LIST_NEW_API_CALL_SUCCESS,
  GET_PRODUCT_LIST_NEW_API_CALL_FAILURE,
  GET_PRODUCT_DETAIL,
  GET_PRODUCT_DETAIL_SUCCESS,
  GET_PRODUCT_DETAIL_FAILURE,
  ADD_PRODUCT,
  ADD_PRODUCT_SUCCESS,
  ADD_PRODUCT_FAILURE,
  UPDATE_PRODUCT_CRM,
  UPDATE_PRODUCT_SUCCESS_CRM,
  UPDATE_PRODUCT_FAILURE_CRM,
  DELETE_PRODUCT,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAILURE,
  SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING,
  SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING_SUCCESS,
  SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING_FAILURE,
  SEARCH_PRODUCTS_PRICING,
  SEARCH_PRODUCTS_PRICING_SUCCESS,
  SEARCH_PRODUCTS_PRICING_FAILURE,
  CREATE_PRODUCTS_PRICING,
  CREATE_PRODUCTS_PRICING_SUCCESS,
  CREATE_PRODUCTS_PRICING_FAILURE,
  UPDATE_PRODUCTS_PRICING,
  UPDATE_PRODUCTS_PRICING_SUCCESS,
  UPDATE_PRODUCTS_PRICING_FAILURE,
  DELETE_PRODUCTS_PRICING,
  DELETE_PRODUCTS_PRICING_SUCCESS,
  DELETE_PRODUCTS_PRICING_FAILURE,
  SEARCH_PRODUCT_PRICE,
  SEARCH_PRODUCT_PRICE_SUCCESS,
  SEARCH_PRODUCT_PRICE_FAILURE,
  CREATE_PRODUCT_PRICE,
  CREATE_PRODUCT_PRICE_SUCCESS,
  CREATE_PRODUCT_PRICE_FAILURE,
  UPDATE_PRODUCT_PRICE,
  UPDATE_PRODUCT_PRICE_SUCCESS,
  UPDATE_PRODUCT_PRICE_FAILURE,
  DELETE_PRODUCT_PRICE,
  DELETE_PRODUCT_PRICE_SUCCESS,
  DELETE_PRODUCT_PRICE_FAILURE,
  GET_PRODUCTS_PRICING_DATA,
  GET_PRODUCTS_PRICING_DATA_SUCCESS,
  GET_PRODUCTS_PRICING_DATA_FAILURE,
  GET_PRODUCTS_RECENT_ACTIVITY,
  GET_PRODUCTS_RECENT_ACTIVITY_SUCCESS,
  GET_PRODUCTS_RECENT_ACTIVITY_FAILURE,
  GET_PRODUCTS_PRICING_LIST,
  GET_PRODUCTS_PRICING_LIST_SUCCESS,
  GET_PRODUCTS_PRICING_LIST_FAILURE,
  GET_FOOD_ALLERGEN_LIST,
  GET_FOOD_ALLERGEN_LIST_SUCCESS,
  GET_FOOD_ALLERGEN_LIST_FAILURE,
  GET_FOOD_ALLERGEN_DATA,
  GET_FOOD_ALLERGEN_DATA_SUCCESS,
  GET_FOOD_ALLERGEN_DATA_FAILURE,
  CREATE_FOOD_ALLERGEN,
  CREATE_FOOD_ALLERGEN_SUCCESS,
  CREATE_FOOD_ALLERGEN_FAILURE,
  UPDATE_FOOD_ALLERGEN,
  UPDATE_FOOD_ALLERGEN_SUCCESS,
  UPDATE_FOOD_ALLERGEN_FAILURE,
  DELETE_FOOD_ALLERGEN,
  DELETE_FOOD_ALLERGEN_SUCCESS,
  DELETE_FOOD_ALLERGEN_FAILURE,
  GET_FOOD_DIET_TYPE_LIST,
  GET_FOOD_DIET_TYPE_LIST_SUCCESS,
  GET_FOOD_DIET_TYPE_LIST_FAILURE,
  GET_FOOD_DIET_TYPE_DATA,
  GET_FOOD_DIET_TYPE_DATA_SUCCESS,
  GET_FOOD_DIET_TYPE_DATA_FAILURE,
  CREATE_FOOD_DIET_TYPE,
  CREATE_FOOD_DIET_TYPE_SUCCESS,
  CREATE_FOOD_DIET_TYPE_FAILURE,
  UPDATE_FOOD_DIET_TYPE,
  UPDATE_FOOD_DIET_TYPE_SUCCESS,
  UPDATE_FOOD_DIET_TYPE_FAILURE,
  DELETE_FOOD_DIET_TYPE,
  DELETE_FOOD_DIET_TYPE_SUCCESS,
  DELETE_FOOD_DIET_TYPE_FAILURE,
  GET_PRODUCT_ATTRIBUTE_LIST,
  GET_PRODUCT_ATTRIBUTE_LIST_SUCCESS,
  GET_PRODUCT_ATTRIBUTE_LIST_FAILURE,
  GET_PRODUCT_ATTRIBUTE_DATA,
  GET_PRODUCT_ATTRIBUTE_DATA_SUCCESS,
  GET_PRODUCT_ATTRIBUTE_DATA_FAILURE,
  CREATE_PRODUCT_ATTRIBUTE,
  CREATE_PRODUCT_ATTRIBUTE_SUCCESS,
  CREATE_PRODUCT_ATTRIBUTE_FAILURE,
  UPDATE_PRODUCT_ATTRIBUTE,
  UPDATE_PRODUCT_ATTRIBUTE_SUCCESS,
  UPDATE_PRODUCT_ATTRIBUTE_FAILURE,
  DELETE_PRODUCT_ATTRIBUTE,
  DELETE_PRODUCT_ATTRIBUTE_SUCCESS,
  DELETE_PRODUCT_ATTRIBUTE_FAILURE,
  GET_PRODUCT_ATTRIBUTE_VALUE_LIST,
  GET_PRODUCT_ATTRIBUTE_VALUE_LIST_SUCCESS,
  GET_PRODUCT_ATTRIBUTE_VALUE_LIST_FAILURE,
  GET_PRODUCT_ATTRIBUTE_VALUE_DATA,
  GET_PRODUCT_ATTRIBUTE_VALUE_DATA_SUCCESS,
  GET_PRODUCT_ATTRIBUTE_VALUE_DATA_FAILURE,
  CREATE_PRODUCT_ATTRIBUTE_VALUE,
  CREATE_PRODUCT_ATTRIBUTE_VALUE_SUCCESS,
  CREATE_PRODUCT_ATTRIBUTE_VALUE_FAILURE,
  UPDATE_PRODUCT_ATTRIBUTE_VALUE,
  UPDATE_PRODUCT_ATTRIBUTE_VALUE_SUCCESS,
  UPDATE_PRODUCT_ATTRIBUTE_VALUE_FAILURE,
  DELETE_PRODUCT_ATTRIBUTE_VALUE,
  DELETE_PRODUCT_ATTRIBUTE_VALUE_SUCCESS,
  DELETE_PRODUCT_ATTRIBUTE_VALUE_FAILURE,
  GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST,
  GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST_SUCCESS,
  GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST_FAILURE,
  GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA,
  GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA_SUCCESS,
  GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA_FAILURE,
  CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE,
  CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_SUCCESS,
  CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_FAILURE,
  UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE,
  UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_SUCCESS,
  UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_FAILURE,
  DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE,
  DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE_SUCCESS,
  DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE_FAILURE,
} from "./actionType";

// Reducer for Products

const initialState = {
  productSelfServeWidgetData: null,
  productSelfServeWidgetProductList: [],
  productSelfServeWidgetRenderLoading: false,
  productSelfServePublicBookSuccess: null,
  productSelfServePublicBookLoading: false,
  productSelfServeWidgetCheckAvailabilityResult: null,
  productSelfServeWidgetCheckAvailabilityLoading: false,

  productsList: [],
  productListLoading: false,
  //GET_PRODUCT_LIST_NEW_API_CALL
  productsListNewApiCall: [],
  productsListNewApiCallLoading: false,

  productDetails: {},
  productDetailLoading: false,
  addProductSuccess: [],
  addProductSuccessLoading: false,
  updateProductSuccess: [],
  updateProductSuccessLoading: false,
  deleteProductSuccess: [],
  searchProductsAllowedTimeTracking: [],
  searchProductsAllowedTimeTrackingLoading: false,

  searchProductsPricing: [],
  searchProductsPricingLoading: false,

  createProductsPricingSuccess: [],
  createUpdateLoading: false,

  updateProductsPricingSuccess: [],

  deleteProductsPricingSuccess: [],
  deleteProductsPricingLoading: false,

  // Task 24858 - ProductPrice (the product's dated price schedule).
  searchProductPriceSuccess: [],
  createProductPriceSuccess: [],
  updateProductPriceSuccess: [],
  deleteProductPriceSuccess: [],
  productPriceSaving: false,

  getProductsPricingData: [],
  getProductsPricingDataLoading: false,

  getProductsRecentActivity: [],
  getProductsRecentActivityLoading: false,

  getProductsPricingList: [],
  getProductsPricingListLoading: false,

  foodAllergenList: [],
  foodAllergenListLoading: false,
  foodAllergenData: [],
  foodAllergenDataLoading: false,
  createFoodAllergenSuccess: [],
  updateFoodAllergenSuccess: [],
  deleteFoodAllergenSuccess: [],

  foodDietTypeList: [],
  foodDietTypeListLoading: false,
  foodDietTypeData: [],
  foodDietTypeDataLoading: false,
  createFoodDietTypeSuccess: [],
  updateFoodDietTypeSuccess: [],
  deleteFoodDietTypeSuccess: [],

  productAttributeList: [],
  productAttributeListLoading: false,
  productAttributeData: [],
  productAttributeDataLoading: false,
  createProductAttributeSuccess: [],
  updateProductAttributeSuccess: [],
  deleteProductAttributeSuccess: [],

  productAttributeValueList: [],
  productAttributeValueListLoading: false,
  productAttributeValueData: [],
  productAttributeValueDataLoading: false,
  createProductAttributeValueSuccess: [],
  updateProductAttributeValueSuccess: [],
  deleteProductAttributeValueSuccess: [],

  productAttributeValuePriceList: [],
  productAttributeValuePriceListLoading: false,
  productAttributeValuePriceData: [],
  productAttributeValuePriceDataLoading: false,
  createProductAttributeValuePriceSuccess: [],
  updateProductAttributeValuePriceSuccess: [],
  deleteProductAttributeValuePriceSuccess: [],
};

const Products = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRODUCT_SELF_SERVE_WIDGET_RENDER:
      return {
        ...state,
        productSelfServeWidgetRenderLoading: true,
      };
    case GET_PRODUCT_SELF_SERVE_WIDGET_RENDER_SUCCESS:
      return {
        ...state,
        productSelfServeWidgetData: action.payload?.productselfservewidget_data || null,
        productSelfServeWidgetProductList: action.payload?.product_list || [],
        productSelfServeWidgetRenderLoading: false,
      };
    case GET_PRODUCT_SELF_SERVE_WIDGET_RENDER_FAILURE:
      return {
        ...state,
        productSelfServeWidgetRenderLoading: false,
      };
    case POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK:
      return { ...state, productSelfServePublicBookLoading: true, productSelfServePublicBookSuccess: null };
    case POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK_SUCCESS:
      return { ...state, productSelfServePublicBookLoading: false, productSelfServePublicBookSuccess: action.payload };
    case POST_PRODUCT_SELF_SERVE_PUBLIC_BOOK_FAILURE:
      return { ...state, productSelfServePublicBookLoading: false };
    case POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY:
      return { ...state, productSelfServeWidgetCheckAvailabilityLoading: true, productSelfServeWidgetCheckAvailabilityResult: null };
    case POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY_SUCCESS:
      return { ...state, productSelfServeWidgetCheckAvailabilityLoading: false, productSelfServeWidgetCheckAvailabilityResult: action.payload };
    case POST_PRODUCT_SELF_SERVE_WIDGET_CHECK_AVAILABILITY_FAILURE:
      return { ...state, productSelfServeWidgetCheckAvailabilityLoading: false };

    case GET_PRODUCT_LIST:
      return {
        ...state,
        productListLoading: true,
      };
    case GET_PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        productsList: action.payload,
        productListLoading: false,
      };
    case GET_PRODUCT_LIST_FAILURE:
      return {
        ...state,
        productListLoading: false,
      };
    //GET_PRODUCT_LIST_NEW_API_CALL
    case GET_PRODUCT_LIST_NEW_API_CALL:
      return {
        ...state,
        productsListNewApiCallLoading: true,
      };
    case GET_PRODUCT_LIST_NEW_API_CALL_SUCCESS:
      return {
        ...state,
        productsListNewApiCall: action.payload,
        productsListNewApiCallLoading: false,
      };
    case GET_PRODUCT_LIST_NEW_API_CALL_FAILURE:
      return {
        ...state,
        productsListNewApiCallLoading: false,
        productsListNewApiCall: action.payload,
      };
    case GET_PRODUCT_DETAIL:
      return {
        ...state,
        productDetailLoading: true,
      };
    case GET_PRODUCT_DETAIL_SUCCESS:
      return {
        ...state,
        productDetails: action.payload,
        productDetailLoading: false,
      };
    case GET_PRODUCT_DETAIL_FAILURE:
      return {
        ...state,
        productDetailLoading: false,
      };
    case ADD_PRODUCT:
      return {
        ...state,
        addProductSuccessLoading: true,
      };
    case ADD_PRODUCT_SUCCESS:
      return {
        ...state,
        addProductSuccess: action.payload,
        addProductSuccessLoading: false,
      };
    case ADD_PRODUCT_FAILURE:
      return {
        ...state,
        addProductSuccessLoading: false,
      };
    case UPDATE_PRODUCT_CRM:
      return {
        ...state,
        updateProductSuccessLoading: true,
      };
    case UPDATE_PRODUCT_SUCCESS_CRM:
      return {
        ...state,
        updateProductSuccess: action.payload,
        updateProductSuccessLoading: false,
      };
    case UPDATE_PRODUCT_FAILURE_CRM:
      return {
        ...state,
        updateProductSuccessLoading: false,
      };
    case DELETE_PRODUCT:
      return {
        ...state,
      };
    case DELETE_PRODUCT_SUCCESS:
      return {
        ...state,
        deleteProductSuccess: action.payload,
      };
    case DELETE_PRODUCT_FAILURE:
      return {
        ...state,
      };
    case SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING:
      return {
        ...state,
        searchProductsAllowedTimeTrackingLoading: true,
      };
    case SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING_SUCCESS:
      return {
        ...state,
        searchProductsAllowedTimeTracking: action.payload,
        searchProductsAllowedTimeTrackingLoading: false,
      };
    case SEARCH_PRODUCTS_ALLOWED_TIME_TRACKING_FAILURE:
      return {
        ...state,
        searchProductsAllowedTimeTrackingLoading: false,
        searchProductsAllowedTimeTracking: action.payload,
      };
    case SEARCH_PRODUCTS_PRICING:
      return {
        ...state,
        searchProductsPricingLoading: true,
      };
    case SEARCH_PRODUCTS_PRICING_SUCCESS:
      return {
        ...state,
        searchProductsPricing: action.payload,
        searchProductsPricingLoading: false,
      };
    case SEARCH_PRODUCTS_PRICING_FAILURE:
      return {
        ...state,
        searchProductsPricingLoading: false,
        searchProductsPricing: action.payload,
      };
    case CREATE_PRODUCTS_PRICING:
      return {
        ...state,
        createUpdateLoading: true,
      };
    case CREATE_PRODUCTS_PRICING_SUCCESS:
      return {
        ...state,
        createProductsPricingSuccess: action.payload,
        createUpdateLoading: false,
      };
    case CREATE_PRODUCTS_PRICING_FAILURE:
      return {
        ...state,
        createUpdateLoading: false,
        createProductsPricingSuccess: action.payload,
      };
    case UPDATE_PRODUCTS_PRICING:
      return {
        ...state,
        createUpdateLoading: true,
      };
    case UPDATE_PRODUCTS_PRICING_SUCCESS:
      return {
        ...state,
        updateProductsPricingSuccess: action.payload,
        createUpdateLoading: false,
      };
    case UPDATE_PRODUCTS_PRICING_FAILURE:
      return {
        ...state,
        createUpdateLoading: false,
        updateProductsPricingSuccess: action.payload,
      };
    case DELETE_PRODUCTS_PRICING:
      return {
        ...state,
        deleteProductsPricingLoading: true,
      };
    case DELETE_PRODUCTS_PRICING_SUCCESS:
      return {
        ...state,
        deleteProductsPricingSuccess: action.payload,
        deleteProductsPricingLoading: false,
      };
    case DELETE_PRODUCTS_PRICING_FAILURE:
      return {
        ...state,
        deleteProductsPricingLoading: false,
        deleteProductsPricingSuccess: action.payload,
      };

    // Task 24858 - ProductPrice (dated price schedule). One shared saving flag:
    // the schedule editor only ever has a single write in flight, and the
    // screen disables its buttons off it.
    case SEARCH_PRODUCT_PRICE:
      return { ...state, productPriceSaving: true };
    case SEARCH_PRODUCT_PRICE_SUCCESS:
    case SEARCH_PRODUCT_PRICE_FAILURE:
      return {
        ...state,
        productPriceSaving: false,
        searchProductPriceSuccess: action.payload,
      };
    case CREATE_PRODUCT_PRICE:
      return { ...state, productPriceSaving: true };
    case CREATE_PRODUCT_PRICE_SUCCESS:
    case CREATE_PRODUCT_PRICE_FAILURE:
      return {
        ...state,
        productPriceSaving: false,
        createProductPriceSuccess: action.payload,
      };
    case UPDATE_PRODUCT_PRICE:
      return { ...state, productPriceSaving: true };
    case UPDATE_PRODUCT_PRICE_SUCCESS:
    case UPDATE_PRODUCT_PRICE_FAILURE:
      return {
        ...state,
        productPriceSaving: false,
        updateProductPriceSuccess: action.payload,
      };
    case DELETE_PRODUCT_PRICE:
      return { ...state, productPriceSaving: true };
    case DELETE_PRODUCT_PRICE_SUCCESS:
    case DELETE_PRODUCT_PRICE_FAILURE:
      return {
        ...state,
        productPriceSaving: false,
        deleteProductPriceSuccess: action.payload,
      };
    case GET_PRODUCTS_PRICING_DATA:
      return {
        ...state,
        getProductsPricingDataLoading: true,
      };
    case GET_PRODUCTS_PRICING_DATA_SUCCESS:
      return {
        ...state,
        getProductsPricingData: action.payload,
        getProductsPricingDataLoading: false,
      };
    case GET_PRODUCTS_PRICING_DATA_FAILURE:
      return {
        ...state,
        getProductsPricingDataLoading: false,
        getProductsPricingData: action.payload,
      };
    case GET_PRODUCTS_RECENT_ACTIVITY:
      return {
        ...state,
        getProductsRecentActivityLoading: true,
      };
    case GET_PRODUCTS_RECENT_ACTIVITY_SUCCESS:
      return {
        ...state,
        getProductsRecentActivity: action.payload,
        getProductsRecentActivityLoading: false,
      };
    case GET_PRODUCTS_RECENT_ACTIVITY_FAILURE:
      return {
        ...state,
        getProductsRecentActivityLoading: false,
        getProductsRecentActivity: action.payload,
      };
    case GET_PRODUCTS_PRICING_LIST:
      return {
        ...state,
        getProductsPricingListLoading: true,
      };
    case GET_PRODUCTS_PRICING_LIST_SUCCESS:
      return {
        ...state,
        getProductsPricingList: action.payload,
        getProductsPricingListLoading: false,
      };
    case GET_PRODUCTS_PRICING_LIST_FAILURE:
      return {
        ...state,
        getProductsPricingListLoading: false,
        getProductsPricingList: action.payload,
      };

    case GET_FOOD_ALLERGEN_LIST:
      return {
        ...state,
        foodAllergenListLoading: true,
      };
    case GET_FOOD_ALLERGEN_LIST_SUCCESS:
      return {
        ...state,
        foodAllergenList: action.payload,
        foodAllergenListLoading: false,
      };
    case GET_FOOD_ALLERGEN_LIST_FAILURE:
      return {
        ...state,
        foodAllergenListLoading: false,
        foodAllergenList: action.payload,
      };
    case GET_FOOD_ALLERGEN_DATA:
      return {
        ...state,
        foodAllergenDataLoading: true,
      };
    case GET_FOOD_ALLERGEN_DATA_SUCCESS:
      return {
        ...state,
        foodAllergenData: action.payload,
        foodAllergenDataLoading: false,
      };
    case GET_FOOD_ALLERGEN_DATA_FAILURE:
      return {
        ...state,
        foodAllergenDataLoading: false,
        foodAllergenData: action.payload,
      };
    case CREATE_FOOD_ALLERGEN:
      return {
        ...state,
        createUpdateLoading: true,
      };
    case CREATE_FOOD_ALLERGEN_SUCCESS:
      return {
        ...state,
        createFoodAllergenSuccess: action.payload,
        createUpdateLoading: false,
      };
    case CREATE_FOOD_ALLERGEN_FAILURE:
      return {
        ...state,
        createUpdateLoading: false,
        createFoodAllergenSuccess: action.payload,
      };
    case UPDATE_FOOD_ALLERGEN:
      return {
        ...state,
        createUpdateLoading: true,
      };
    case UPDATE_FOOD_ALLERGEN_SUCCESS:
      return {
        ...state,
        updateFoodAllergenSuccess: action.payload,
        createUpdateLoading: false,
      };
    case UPDATE_FOOD_ALLERGEN_FAILURE:
      return {
        ...state,
        createUpdateLoading: false,
        updateFoodAllergenSuccess: action.payload,
      };
    case DELETE_FOOD_ALLERGEN:
      return {
        ...state,
      };
    case DELETE_FOOD_ALLERGEN_SUCCESS:
      return {
        ...state,
        deleteFoodAllergenSuccess: action.payload,
      };
    case DELETE_FOOD_ALLERGEN_FAILURE:
      return {
        ...state,
      };

    case GET_FOOD_DIET_TYPE_LIST:
      return {
        ...state,
        foodDietTypeListLoading: true,
      };
    case GET_FOOD_DIET_TYPE_LIST_SUCCESS:
      return {
        ...state,
        foodDietTypeList: action.payload,
        foodDietTypeListLoading: false,
      };
    case GET_FOOD_DIET_TYPE_LIST_FAILURE:
      return {
        ...state,
        foodDietTypeListLoading: false,
        foodDietTypeList: action.payload,
      };
    case GET_FOOD_DIET_TYPE_DATA:
      return {
        ...state,
        foodDietTypeDataLoading: true,
      };
    case GET_FOOD_DIET_TYPE_DATA_SUCCESS:
      return {
        ...state,
        foodDietTypeData: action.payload,
        foodDietTypeDataLoading: false,
      };
    case GET_FOOD_DIET_TYPE_DATA_FAILURE:
      return {
        ...state,
        foodDietTypeDataLoading: false,
        foodDietTypeData: action.payload,
      };
    case CREATE_FOOD_DIET_TYPE:
      return {
        ...state,
        createUpdateLoading: true,
      };
    case CREATE_FOOD_DIET_TYPE_SUCCESS:
      return {
        ...state,
        createFoodDietTypeSuccess: action.payload,
        createUpdateLoading: false,
      };
    case CREATE_FOOD_DIET_TYPE_FAILURE:
      return {
        ...state,
        createUpdateLoading: false,
        createFoodDietTypeSuccess: action.payload,
      };
    case UPDATE_FOOD_DIET_TYPE:
      return {
        ...state,
        createUpdateLoading: true,
      };
    case UPDATE_FOOD_DIET_TYPE_SUCCESS:
      return {
        ...state,
        updateFoodDietTypeSuccess: action.payload,
        createUpdateLoading: false,
      };
    case UPDATE_FOOD_DIET_TYPE_FAILURE:
      return {
        ...state,
        createUpdateLoading: false,
        updateFoodDietTypeSuccess: action.payload,
      };
    case DELETE_FOOD_DIET_TYPE:
      return {
        ...state,
      };
    case DELETE_FOOD_DIET_TYPE_SUCCESS:
      return {
        ...state,
        deleteFoodDietTypeSuccess: action.payload,
      };
    case DELETE_FOOD_DIET_TYPE_FAILURE:
      return {
        ...state,
      };

    case GET_PRODUCT_ATTRIBUTE_LIST:
      return {
        ...state,
        productAttributeListLoading: true,
      };
    case GET_PRODUCT_ATTRIBUTE_LIST_SUCCESS:
      return {
        ...state,
        productAttributeList: action.payload,
        productAttributeListLoading: false,
      };
    case GET_PRODUCT_ATTRIBUTE_LIST_FAILURE:
      return {
        ...state,
        productAttributeListLoading: false,
        productAttributeList: action.payload,
      };
    case GET_PRODUCT_ATTRIBUTE_DATA:
      return {
        ...state,
        productAttributeDataLoading: true,
      };
    case GET_PRODUCT_ATTRIBUTE_DATA_SUCCESS:
      return {
        ...state,
        productAttributeData: action.payload,
        productAttributeDataLoading: false,
      };
    case GET_PRODUCT_ATTRIBUTE_DATA_FAILURE:
      return {
        ...state,
        productAttributeDataLoading: false,
        productAttributeData: action.payload,
      };
    case CREATE_PRODUCT_ATTRIBUTE:
      return {
        ...state,
        createUpdateLoading: true,
      };
    case CREATE_PRODUCT_ATTRIBUTE_SUCCESS:
      return {
        ...state,
        createProductAttributeSuccess: action.payload,
        createUpdateLoading: false,
      };
    case CREATE_PRODUCT_ATTRIBUTE_FAILURE:
      return {
        ...state,
        createProductAttributeSuccess: action.payload,
        createUpdateLoading: false,
      };
    case UPDATE_PRODUCT_ATTRIBUTE:
      return {
        ...state,
        createUpdateLoading: true,
      };
    case UPDATE_PRODUCT_ATTRIBUTE_SUCCESS:
      return {
        ...state,
        updateProductAttributeSuccess: action.payload,
        createUpdateLoading: false,
      };
    case UPDATE_PRODUCT_ATTRIBUTE_FAILURE:
      return {
        ...state,
        updateProductAttributeSuccess: action.payload,
        createUpdateLoading: false,
      };
    case DELETE_PRODUCT_ATTRIBUTE:
      return {
        ...state,
      };
    case DELETE_PRODUCT_ATTRIBUTE_SUCCESS:
      return {
        ...state,
        deleteProductAttributeSuccess: action.payload,
      };
    case DELETE_PRODUCT_ATTRIBUTE_FAILURE:
      return {
        ...state,
      };

    case GET_PRODUCT_ATTRIBUTE_VALUE_LIST:
      return {
        ...state,
        productAttributeValueListLoading: true,
      };
    case GET_PRODUCT_ATTRIBUTE_VALUE_LIST_SUCCESS:
      return {
        ...state,
        productAttributeValueList: action.payload,
        productAttributeValueListLoading: false,
      };
    case GET_PRODUCT_ATTRIBUTE_VALUE_LIST_FAILURE:
      return {
        ...state,
        productAttributeValueListLoading: false,
        productAttributeValueList: action.payload,
      };
    case GET_PRODUCT_ATTRIBUTE_VALUE_DATA:
      return {
        ...state,
        productAttributeValueDataLoading: true,
      };
    case GET_PRODUCT_ATTRIBUTE_VALUE_DATA_SUCCESS:
      return {
        ...state,
        productAttributeValueData: action.payload,
        productAttributeValueDataLoading: false,
      };
    case GET_PRODUCT_ATTRIBUTE_VALUE_DATA_FAILURE:
      return {
        ...state,
        productAttributeValueDataLoading: false,
        productAttributeValueData: action.payload,
      };
    case CREATE_PRODUCT_ATTRIBUTE_VALUE:
      return {
        ...state,
        createUpdateLoading: true,
      };
    case CREATE_PRODUCT_ATTRIBUTE_VALUE_SUCCESS:
      return {
        ...state,
        createProductAttributeValueSuccess: action.payload,
        createUpdateLoading: false,
      };
    case CREATE_PRODUCT_ATTRIBUTE_VALUE_FAILURE:
      return {
        ...state,
        createProductAttributeValueSuccess: action.payload,
        createUpdateLoading: false,
      };
    case UPDATE_PRODUCT_ATTRIBUTE_VALUE:
      return {
        ...state,
        createUpdateLoading: true,
      };
    case UPDATE_PRODUCT_ATTRIBUTE_VALUE_SUCCESS:
      return {
        ...state,
        updateProductAttributeValueSuccess: action.payload,
        createUpdateLoading: false,
      };
    case UPDATE_PRODUCT_ATTRIBUTE_VALUE_FAILURE:
      return {
        ...state,
        updateProductAttributeValueSuccess: action.payload,
        createUpdateLoading: false,
      };
    case DELETE_PRODUCT_ATTRIBUTE_VALUE:
      return {
        ...state,
      };
    case DELETE_PRODUCT_ATTRIBUTE_VALUE_SUCCESS:
      return {
        ...state,
        deleteProductAttributeValueSuccess: action.payload,
      };
    case DELETE_PRODUCT_ATTRIBUTE_VALUE_FAILURE:
      return {
        ...state,
      };

    case GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST:
      return {
        ...state,
        productAttributeValuePriceListLoading: true,
      };
    case GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST_SUCCESS:
      return {
        ...state,
        productAttributeValuePriceList: action.payload,
        productAttributeValuePriceListLoading: false,
      };
    case GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_LIST_FAILURE:
      return {
        ...state,
        productAttributeValuePriceListLoading: false,
        productAttributeValuePriceList: action.payload,
      };
    case GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA:
      return {
        ...state,
        productAttributeValuePriceDataLoading: true,
      };
    case GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA_SUCCESS:
      return {
        ...state,
        productAttributeValuePriceData: action.payload,
        productAttributeValuePriceDataLoading: false,
      };
    case GET_PRODUCT_ATTRIBUTE_VALUE_PRICE_DATA_FAILURE:
      return {
        ...state,
        productAttributeValuePriceDataLoading: false,
        productAttributeValuePriceData: action.payload,
      };
    case CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE:
      return {
        ...state,
        createUpdateLoading: true,
      };
    case CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_SUCCESS:
      return {
        ...state,
        createProductAttributeValuePriceSuccess: action.payload,
        createUpdateLoading: false,
      };
    case CREATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_FAILURE:
      return {
        ...state,
        createProductAttributeValuePriceSuccess: action.payload,
        createUpdateLoading: false,
      };
    case UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE:
      return {
        ...state,
        createUpdateLoading: true,
      };
    case UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_SUCCESS:
      return {
        ...state,
        updateProductAttributeValuePriceSuccess: action.payload,
        createUpdateLoading: false,
      };
    case UPDATE_PRODUCT_ATTRIBUTE_VALUE_PRICE_FAILURE:
      return {
        ...state,
        updateProductAttributeValuePriceSuccess: action.payload,
        createUpdateLoading: false,
      };
    case DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE:
      return {
        ...state,
      };
    case DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE_SUCCESS:
      return {
        ...state,
        deleteProductAttributeValuePriceSuccess: action.payload,
      };
    case DELETE_PRODUCT_ATTRIBUTE_VALUE_PRICE_FAILURE:
      return {
        ...state,
      };

    default:
      return state;
  }
};

export default Products;
